import React from 'react'
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Projectcolors from "../../Utils/Colors";
import HomeIcon from '@mui/icons-material/Home';
import HelpIcon from '@mui/icons-material/Help';
import Selexlogo from '../../images/SelexMB Final.png';
import optimizelogo from '../../images/logooptimizegsfinal.png'
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { create } from '../../Store/projectPermission/permssionReducer';
import Tooltip from "@mui/material/Tooltip";
import gpticon from "../../images/gpticon.png";
import selexsuite from "../../images/SelexSuite.png";





function SelexSolNavbar(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch()


  function logout(){
    sessionStorage.removeItem("usertoken");
    sessionStorage.removeItem("projectID");
    sessionStorage.removeItem("projectName");
    dispatch(create([{empty:true}]))

    if (props.admin){
      navigate("/admin");

    }
    else{
      navigate("/login");
    }
  }
  return (
    <div style={{paddingBottom:"60px"}}>    
    <Box>
    <AppBar  sx={{backgroundColor:'white',height:60}} >
      <Toolbar sx={{position:"sticky"}}>
      <a href="/select"><img alt="selexlogo" style = {{ height:'40px',width:'100px',marginTop:'0px',marginleft:'3px',marginRight:"5px",marginBottom:"5px"}} src = {optimizelogo}/></a>


        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          href="/"
          
          
        >
          <HomeIcon  sx={{fontSize:"33px",borderLeft: '0.01em solid white',marginLeft:0.5,paddingLeft:1,color:Projectcolors.primary}} />
        </IconButton>
      
              <div style={{display: "block",
          marginLeft: "36%",
          marginRight: "auto"}}
 >       <a href="/select"><img alt="selexlogo" style = {{ height:'160px',width:'220px',marginTop:'0px',marginleft:'0px',marginRight:"5px",marginBottom:"5px"}} src = {selexsuite}/></a>

      </div>

      <Tooltip
                                title={
                                  <Typography fontSize={15}>
                                    SelexGPT
                                  </Typography>
                                }
                                sx={{ fontSize: 15 }}
                              >
                                 <IconButton
          edge="end"
          color="inherit"
          aria-label="menu"
          href="/gpt"
           
        >
          <img
                alt="model"
                src={gpticon}
                style={{
                  marginRight: 10,
                  height:34,
                  width:34
                }}
              />
        </IconButton>
                                
                              </Tooltip>
     
                              
        

      </Toolbar>
    </AppBar>
  </Box>
</div>
  )
}

export default SelexSolNavbar